import React from "react";
import { BulbOutlined, CheckCircleOutlined, QuestionCircleOutlined, TeamOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import GamePage from "./GamePage";

const { Paragraph } = Typography;

const Quizzler: React.FC = () => {
    const { t } = useTranslation();

    return (
        <GamePage
            game="quizzler"
            tagColor="gold"
            instructionIcons={[
                <TeamOutlined key="teams" />,
                <QuestionCircleOutlined key="question" />,
                <BulbOutlined key="wrong" />,
                <CheckCircleOutlined key="right" />,
            ]}
        >
            <Paragraph>{t("games.details.quizzler.extra")}</Paragraph>
            <Paragraph type="secondary" style={{ marginBottom: 0 }}>
                {t("games.details.quizzler.tip")}
            </Paragraph>
        </GamePage>
    );
};

export default Quizzler;
